import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AmountEffects, amountReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([AmountEffects]), StoreModule.forFeature(`amount`, amountReducer)]
})
export class AmountStateModule {}
